import { RouteRecordRaw } from 'vue-router'

const requisition: Array<RouteRecordRaw> = [
    {
        path: '/requisition',
        name: 'requisition',
        redirect: '/requisition/index',
        component: () => import('@/views/children.vue'),
        children: [
            {
                path: '/requisition/index',
                name: 'requisition_index',
                meta: {
                    title: '申请单',
                    keepAlive: true
                },
                component: () => import('@/views/requisition/index.vue')
            },
            {
                path: '/requisition/rework',
                name: 'requisition_rework',
                meta: {
                    title: '返工返修申请',
                    keepAlive: false
                },
                component: () => import('@/views/requisition/rework.vue')
            },
            {
                path: '/requisition/reworkDetails',
                name: 'reworkDetails',
                meta: {
                    title: '返工返修详情',
                    keepAlive: false
                },
                component: () => import('@/views/requisition/reworkDetails.vue')
            },
            {
                path: '/requisition/scrapped',
                name: 'requisition_scrapped',
                meta: {
                    title: '工序报废申请',
                    keepAlive: false
                },
                component: () => import('@/views/requisition/scrapped.vue')
            },
            {
                path: '/requisition/scrapDetails',
                name: 'scrapDetails',
                meta: {
                    title: '工序报废详情',
                    keepAlive: false
                },
                component: () => import('@/views/requisition/scrapDetails.vue')
            },
            {
                path: '/requisition/test',
                name: 'requisition_test',
                meta: {
                    title: '检验申请',
                    keepAlive: false
                },
                component: () => import('@/views/requisition/test.vue')
            },
            {
                path: '/requisition/inspectionDetails',
                name: 'inspectionDetails',
                meta: {
                    title: '客返品检验申请详情',
                    keepAlive: false
                },
                component: () => import('@/views/requisition/inspectionDetails.vue')
            }
        ]
    }
]

export default requisition
